module.exports = __webpack_public_path__ + "static/media/cod_burger2-mb-fr.4880b6ca.jpg";